import { configureStore } from '@reduxjs/toolkit';
import { IS_TESTING_ENVIRONMENT } from '../constants/environment';
import inputsReducer from './inputsReducer';
import appConfigReducer from './appConfigReducer';
import dealerReducer from './dealerAndVehicleReducer';
import errorsReducer from './errorsReducer';
import localConfigReducer from './localConfigReducer';
import formReducer from './formReducer';

export const store = configureStore({
  reducer: {
    userInputs: inputsReducer,
    errors: errorsReducer,
    appConfig: appConfigReducer,
    dealerAndVehicleData: dealerReducer,
    localConfig: localConfigReducer,
    contactForm: formReducer,
  },
  devTools: IS_TESTING_ENVIRONMENT,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
